import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';

const RmTickets = ({
  fetchEmTicket,
  employeeTicket,
  postUpdateEMStatus,
  getEmployeeFilterDropDown,
  employeeFilterList,
}) => {
  const headers = [
    'Ticket ID',
    'Site Number',
    'Site Type',
    'Remarks',
    'Created At',
    'Assigned To',
    'Status',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await fetchEmTicket(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    (async () => {
      if (fetchEmTicket) {
        setIsLoading(true);
        await fetchEmTicket({
          site_no: '',
          client_name: '',
          site_type: '',
          status: 3,
          assignee_ids: '',
        });
        await getEmployeeFilterDropDown();
        setIsLoading(false);
      }
    })();
  }, [fetchEmTicket]);

  useEffect(() => {
    (async () => {
      if (refresh === true) {
        setIsLoading(true);
        await fetchEmTicket({
          site_no: '',
          client_name: '',
          site_type: '',
          status: 3,
          assignee_ids: '',
        });
        setIsLoading(false);
      }
    })();
  }, [refresh]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    if(filterData === null){
      await fetchEmTicket({
        site_no: '',
        client_name: '',
        site_type: '',
        status: 3,
        assignee_ids: '',
      }, val.selected + 1);
    }else{
      await fetchEmTicket(filterData, val.selected + 1);
    }
    // await fetchEmTicket(val.selected + 1);
    setIsLoading(false);
  };

  useEffect(() => {
    const actions1 = [
      { name: 'View Details', link: '/dashboard/em-view' },
      { name: 'Approve', link: '' },
      { name: 'Reject', link: '' },
    ];

    const tableData = [
      'id',
      'site_no',
      'site_type',
      'remarks',
      'created_at',
      'assigned_to',
      'status',
    ];

    if (employeeTicket && employeeTicket.resultSets) {
      const data = employeeTicket.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action: actions1,
          }
        )
      );

      setListData(data);

      setPageCount(Math.ceil(employeeTicket.total / employeeTicket.per_page));
    }
  }, [employeeTicket]);

  return (
    <Layout
      title={localization.approvalEmTicket}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={true}
        headers={headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        detailList={employeeTicket && employeeTicket.resultSets}
        postUpdateEMStatus={postUpdateEMStatus}
        refreshPage={(val) => {
          if (val === true) {
            setRefresh(true);
          }
        }}
        srNo={employeeTicket?.from}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={3}
        listFilterData={employeeFilterList?.sites ? employeeFilterList : null}
        employeeFilterList
      />
    </Layout>
  );
};

export default RmTickets;
